export enum DrillCode {
    COLOR_DASH = "color_dash",
    ARROW_RIGHT_LEFT = "arrow_right_left",
}

export const resolveDrillCode = (code?: string | null): DrillCode =>
    code === DrillCode.ARROW_RIGHT_LEFT ? DrillCode.ARROW_RIGHT_LEFT : DrillCode.COLOR_DASH;
